var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg015Crop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,404.001h-42.001L450,142.002c0-14.531-3.848-28.47-11.061-40.655l67.204-67.204c7.811-7.811,7.811-20.475,0-28.285 s-20.474-7.811-28.284,0l-67.204,67.204C398.47,65.848,384.531,62.001,370,62.001l-262,0.003V20.001c0-11.046-8.954-20-20-20 s-20,8.955-20,20v42.003H20c-11.046,0-20,8.954-20,20s8.955,20,20,20h48v261.997c0,44.112,35.888,80,80,80h261.999v48 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-48H492c11.046,0,20-8.954,20-20C512,412.955,503.046,404.001,492,404.001z  M409.999,404.001H148c-22.056,0-40-17.944-40-40V102.004l262-0.001c3.548,0,7.026,0.459,10.366,1.349L173.858,309.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.142,5.857s10.237-1.952,14.142-5.857L408.65,131.636 c0.89,3.339,1.349,6.817,1.349,10.366V404.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg015Crop);
export default __webpack_public_path__ + "static/media/015-crop.15ac23d3109974e37f5020a36bc21218.svg";
export { ForwardRef as ReactComponent };